import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import { BuyerPaymentsSection } from './BuyerPaymentsSection';
import { FaiAftermarketSection } from './FaiAftermarketSection';
import { FinancingSection } from './FinancingSection';
import { OverviewSection } from './OverviewSection';
import { PayoutsSection } from './PayoutsSection';

export const PaymentsTabContent = () => {
	return (
		<Stack>
			<OverviewSection />
			<Divider />
			<FinancingSection />
			<Divider />
			<FaiAftermarketSection />
			<Divider />
			<BuyerPaymentsSection />
			<Divider />
			<PayoutsSection />
		</Stack>
	);
};
